import {useListKpiTargetsQuery} from "../../apis/kpiApi";
import MainLayout from "../../layouts/MainLayout";
import KPIValueTargetCard from "./KPIValueTargetCard";
import {Outlet} from "react-router-dom";
import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import YearSelector from "../../components/navs/YearSelector";
import {useBSI} from "../../hooks/kpiHooks";

const KPIValuePage = () => {
    const {data, isFetching} = useListKpiTargetsQuery();
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const bsi = useBSI();

    return useMemo(() => {
        if(isFetching) return (<></>);

        const sortedArray = [...(data || [])]
            .filter(kpi => kpi.scorecard && kpi.year === selectedYear && (kpi.timeFrame === 'Annual') && (kpi.type === 'Benchmark' || kpi.type === 'Target'))
            .sort((targetA, targetB) => targetB.weight - targetA.weight);

        return (<MainLayout>
            <div className="kpi-values-page">
                <YearSelector />
                <div className="bsi-panel">
                    <div className="bsi-title">BSI</div>
                    <div className="bsi">{bsi}%</div>
                </div>
                <div className="kpi-values">
                    {sortedArray.map(target => (<KPIValueTargetCard showBsi={true} key={target.id} target={target} path="/kpi/kpis" /> ))}
                </div>
            </div>
            <Outlet />
        </MainLayout>);
    }, [data, isFetching, selectedYear, bsi]);

}

export default KPIValuePage;
